import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('howie_service_area_review', '/howie_service_area_reviews')
const actions = generator.generate()

export default actions
